export interface SkeletonProps {
  /** Anzahl der Platzhalterzeilen. */
  lines?: number;
  /** Form: Zeile, Ueberschrift, Kachel oder Tabellenzeile. */
  shape?: 'text' | 'title' | 'block' | 'row';
  /** Beschreibt, worauf gewartet wird — fuer Screenreader. */
  label?: string;
}

/**
 * Platzhalter waehrend des Ladens.
 *
 * Die Form bildet nach, was gleich kommt. Das ist kein Schmuck: ein
 * Platzhalter in falscher Groesse laesst die Seite beim Eintreffen der Daten
 * springen, und der haeufigste Grund fuer einen Fehlklick ist ein Knopf, der
 * sich im Moment des Klickens verschoben hat.
 *
 * Die Bewegung ist an `prefers-reduced-motion` gebunden — sie hoert auf, wenn
 * das System das verlangt.
 */
export function Skeleton({ lines = 3, shape = 'text', label = 'Wird geladen' }: SkeletonProps) {
  return (
    <div className="skeleton" role="status" aria-label={label} aria-busy="true">
      {Array.from({ length: lines }, (_, index) => (
        <span key={index} className="skeleton__bar" data-shape={shape} aria-hidden="true" />
      ))}
    </div>
  );
}
